import script from "./_id.vue?vue&type=script&setup=true&lang=js"
export * from "./_id.vue?vue&type=script&setup=true&lang=js"

import "./_id.vue?vue&type=style&index=0&id=69c51889&lang=scss"

const __exports__ = script;

export default __exports__